import { registerPlugin } from '@capacitor/core';

const StethoPlugin = registerPlugin('StethoPlugin');

export default StethoPlugin;